import CryptoJS from "crypto-js";

export function hashUrl(url) {
  return CryptoJS.MD5(url + "h").toString();
}
